import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { AccessKeysDashboardQueryKeys } from "modules/AccessKeysDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

type RequestApiKeyPayload = {
  public_account_id: number;
  reason: string;
};

export const useRequestApiKeyMutation = () =>
  useTypedMutation<RequestApiKeyPayload, string>({
    mutationFn: async payload => (await ApiInstance.post("/publicapi/account/key", payload, ENV.dealerBaseURL)).data.api_key,
    onSuccess: ({ public_account_id }, api_key) => {
      const accounts = typedQueryClient.getQueryData(AccessKeysDashboardQueryKeys.accounts);
      if (!accounts) return;

      const accountIdx = accounts.findIndex(account => account.id === public_account_id);
      if (accountIdx === -1) return;

      typedQueryClient.setQueryData(AccessKeysDashboardQueryKeys.accounts, accounts.with(accountIdx, { ...accounts[accountIdx], api_key }));
    }
  });
